import * as React from 'react';
import { observer } from 'mobx-react';

import { BaseItem } from 'shared/newComponents/list';
import { UserIcon } from 'shared/newComponents/icons';
import { ComponentType } from 'shared/entities/components/Component';
import { urls } from 'shared/entities/domain';
import { IconSize } from 'shared/entities/components/Icon';
import {
  TypographyColor,
  TypographySize
} from 'shared/newEntities/components/Typography';
import ProjectSelector from 'shared/newContainers/selectors/ProjectSelector';
import Cabinet from 'shared/newComponents/PageTemplate/Menu/Cabinet';
import { SelectorTriggerSize } from 'shared/newEntities/components/Selector';
import { useUiStore } from 'stores/index';

import './PopupContent.modules.scss';

type Props = {
  close?: () => void;
};

const PopupContent: React.FC<Props> = ({ close }) => {
  const uiStore = useUiStore();

  return (
    <>
      <div styleName="popup-content__selectors">
        <Cabinet styleName="popup-content__selector" />
        <ProjectSelector
          onCreate={close}
          triggerSize={
            uiStore.isMobileSize
              ? SelectorTriggerSize.l
              : SelectorTriggerSize.sm
          }
        />
      </div>
      <BaseItem
        styleName="popup-content__settings"
        title={(t) =>
          t('PageTemplate.TopMenu.User.settings', { ns: 'newComponents' })
        }
        titleIcon={<UserIcon iconSize={IconSize.S} />}
        titleColor={TypographyColor.secondary}
        titleSize={TypographySize.s}
        type={ComponentType.link}
        to={urls.SETTINGS.PROFILE.create()}
      />
    </>
  );
};

export default observer(PopupContent);
